<div class="layout-column full-height">
  <div class="layout-row margin-bottom-10">
    <div class="layout-column">
      <div class="layout-row layout-align-start-center margin-bottom-10">
        <bringoz-icon iconName="skill-outline" class="margin-right-5" classSize="xl" fill="#7E7E7E"></bringoz-icon>
        <span class="br-head-2 primary-102">{{pricePlanDetails.name}}</span>
      </div>
      <div class="layout-row br-body-2 primary-102 margin-bottom-10 layout-row layout-align-start-center gap-1">
        <div *ngIf="pricePlanDetails.createdBy" class="gap-1">
          <span translate>Created by</span>:
          <span>{{pricePlanDetails.createdBy}}</span>
        </div>
        <div *ngIf="pricePlanDetails.createdAt" class="gap-1">
          <span translate>Created on</span>:
          <span>{{pricePlanDetails | bringozFullDate: 'createdAt'}}</span>
        </div>
        <div *ngIf="pricePlanDetails.updatedAt" class="gap-1">
          <span translate>Updated on</span>:
          <span>{{pricePlanDetails | bringozFullDate: 'updatedAt'}}</span>
        </div>
      </div>
      <div *ngIf="pricePlanDetails.entryList.length || pricePlanDetails.parentName"
           class="br-body-2 blue-101 margin-bottom-10 layout-row layout-align-start-center gap-1">
        <div *ngIf="pricePlanDetails.parentName">
          <span translate>Override to</span> {{pricePlanDetails.parentName}}
        </div>
        <div *ngIf="pricePlanProgramsCount" class="gap-1">
          <span translate>Programs</span>:
          <span>{{pricePlanProgramsCount}}</span>
        </div>
      </div>
      <div class="br-body-2 blue-101 gap-1">
        <span translate>Connected accounts</span>:
        <span>{{pricePlanDetails.accountsDetails.length}}</span>
      </div>
    </div>
    <span class="flex"></span>
    <div ngbDropdown container="body">
      <button class="action-menu"
              (click)="$event.stopPropagation();"
              ngbDropdownToggle>
        <bringoz-icon iconName="menu"></bringoz-icon>
      </button>
      <div ngbDropdownMenu aria-labelledby="action-menu">

        <button
          ngbDropdownItem
          *ngxPermissionsOnly="'program.update'"
          (click)="setAsDefaultEvent.emit(pricePlanDetails)">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="skill-outline" [classSize]="'xl'" fill="#7E7E7E"
                          class="margin-right-10"></bringoz-icon>
            <span class="br-body-2 primary-100" translate>Set as default</span>
          </div>
        </button>

        <button
          ngbDropdownItem
          *ngxPermissionsOnly="'program.create'"
          (click)="duplicatePricePlanEvent.emit(pricePlanDetails)">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="copy" [classSize]="'xl'" fill="#7E7E7E" class="margin-right-10"></bringoz-icon>
            <span class="br-body-2 primary-100" translate>Duplicate</span>
          </div>
        </button>

        <button
          ngbDropdownItem
          *ngxPermissionsOnly="'program.create'"
          (click)="createPricePlanChildEvent.emit(pricePlanDetails)">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="plus" [classSize]="'xl'" fill="#7E7E7E" class="margin-right-10"></bringoz-icon>
            <span class="br-body-2 primary-100" translate>Add Child</span>
          </div>
        </button>

        <button
          ngbDropdownItem
          (click)="updatePricePlanAccountsEvent.emit(pricePlanDetails)">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="account" [classSize]="'xl'" fill="#7E7E7E" class="margin-right-10"></bringoz-icon>
            <span class="br-body-2 primary-100" translate>Add Accounts</span>
          </div>
        </button>

        <button ngbDropdownItem
                *ngxPermissionsOnly="'program.update'"
                (click)="editPricePlanEvent.emit(pricePlanDetails)">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="program" [classSize]="'xl'" fill="#7E7E7E" class="margin-right-10"></bringoz-icon>
            <span class="br-body-2 primary-100" translate>Edit Program</span>
          </div>
        </button>

        <button ngbDropdownItem
                *ngxPermissionsOnly="'program.update'"
                (click)="importProgramSettingsEvent.emit(pricePlanDetails)">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="upload" [classSize]="'xl'" fill="#7E7E7E" class="margin-right-10"></bringoz-icon>
            <span class="br-body-2 primary-100" translate>Import Program Settings</span>
          </div>
        </button>

      </div>
    </div>

    <div ngbDropdown container="body">
      <button class="action-menu"
              (click)="$event.stopPropagation();"
              ngbDropdownToggle>
        <bringoz-icon iconName="export-xsl"></bringoz-icon>
      </button>
      <div ngbDropdownMenu aria-labelledby="action-menu">

        <button
          ngbDropdownItem
          (click)="onExportEvent.emit({event: $event, exportType: exportTypes.Excel})">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="export" [classSize]="'xl'" fill="#7E7E7E"
                          class="margin-right-10"></bringoz-icon>
            <span class="br-body-2 primary-100" translate>Excel</span>
          </div>
        </button>

        <button
          ngbDropdownItem
          (click)="onExportEvent.emit({event: $event, exportType: exportTypes.CSV})">
          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="export" [classSize]="'xl'" fill="#7E7E7E"
                          class="margin-right-10"></bringoz-icon>
            <span class="br-body-2 primary-100" translate>CSV</span>
          </div>
        </button>

      </div>
    </div>

  </div>
  <div class="flex layout-column">
    <ul class="nav nav-pills margin-bottom-20" id="bringoz-tabs" role="tablist">

      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="pills-accounts-tab" data-bs-toggle="pill" data-bs-target="#pills-accounts"
                type="button" role="tab" aria-controls="pills-accounts" aria-selected="true">
          <span translate>Accounts</span>
        </button>
      </li>
      <!--      <li class="nav-item" role="presentation">-->
      <!--        <button class="nav-link" id="pills-programs-tab" data-bs-toggle="pill" data-bs-target="#pills-programs"-->
      <!--                type="button" role="tab" aria-controls="pills-programs" aria-selected="false">-->
      <!--          <span translate>Programs</span>-->
      <!--        </button>-->
      <!--      </li>-->
      <!--      <li class="nav-item" role="presentation">-->
      <!--        <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Contact</button>-->
      <!--      </li>-->
    </ul>
    <div class="tab-content flex" id="pills-tabContent">

      <div class="tab-pane fade show active" id="pills-accounts" role="tabpanel" aria-labelledby="pills-accounts-tab">

        <div class="full-height layout-column overflow-x-auto-only">

          <div class="flex layout-column bringoz-table">

            <div class="tr layout-row layout-align-start-center" id="header">
              <div class="th small flex">
                <app-bringoz-checkbox class="margin-right-5"
                                      [isDisabled]="!pricePlanDetails.accountsDetails?.length"
                                      [isChecked]="!!selectedIds?.length"
                                      [isIndeterminate]="!!selectedIds?.length && pricePlanDetails.accountsDetails?.length > selectedIds?.length"
                                      (clickEvent)="onToggleSelectAll()">
                </app-bringoz-checkbox>
                <span>{{'Account Name' | translate}}</span>
              </div>
              <div class="th small flex">{{'External ID' | translate}}</div>
              <div class="th small flex">{{'Branches' | translate}}</div>
              <div class="th small flex">{{'Updated At' | translate}}</div>
            </div>

            <div class="full-height flex layout-column">
              <cdk-virtual-scroll-viewport itemSize="50" class="flex viewport">

                <div class="tr item md-no-proxy hover layout-row layout-align-start-center"
                     *cdkVirtualFor="let account of pricePlanDetails.accountsDetails">

                  <div class="flex td small text-ellipsis layout-row layout-align-start-center">

                    <app-bringoz-checkbox class="margin-right-5"
                                          [isChecked]="selectedKeys[account.id]"
                                          (clickEvent)="onToggle(account.id, selectedKeys[account.id])">
                    </app-bringoz-checkbox>

                    <app-demand-account-link class="flex" [account]="{name: account.name, id: account.id}"
                                             [isAllowCopyButton]="true"></app-demand-account-link>

                  </div>

                  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
                    {{account.externalId}}
                  </div>

                  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
                    <app-bringoz-items-list-display *ngIf="!!account.branches?.length"
                                                    [items]="account.branches | BringozMap : 'name'"
                                                    maxItems="2"></app-bringoz-items-list-display>
                  </div>

                  <div class="flex td small text-ellipsis layout-row layout-align-start-center">
                    {{ account | bringozFullDate: 'updatedAt'}}
                  </div>

                </div>

              </cdk-virtual-scroll-viewport>
            </div>

          </div>
        </div>

      </div>
      <!--      <div class="tab-pane fade" id="pills-programs" role="tabpanel" aria-labelledby="pills-programs-tab">programs</div>-->
      <!--      <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">...</div>-->
    </div>
  </div>
</div>
